import View from './view'
import listComponent from '@/util/proto/listComponent'

import { createDict } from '@/util/dicts'
import global from '@/util/mixin/global'

export default {
  extends: listComponent,
  mixins: [global],
  data() {
    const carCatRequest = () => new Promise((resolve) => {
      this.$request.carCates({ pageSize: 0, search: {} }).then(resp => {
        resolve((resp.data.list || []).map(i => ({
          value: i.id,
          label: i.name,
        })))
      })
    })

    // const searchBoxMore = 
    return {
      data: [],
      params: {},

      columns:[
        {
          title: '车辆编号',
          key: 'carNo',
          minWidth: 50,
        },
        {
          title: '所属企业',
          key: 'companyName',
          minWidth: 130,
        },
        
        {
          title: '车辆类型',
          key: 'categoryName',
          minWidth: 150,
        },
        {
          title: '车牌号',
          key: 'licenseNo',
          minWidth: 100,
        },
        {
          title: '保单号',
          key: 'insuranceNo',
          minWidth: 120,
        },
        {
          title: '操作',
          key: 'action',
          width: 90,
          align: 'center',
          fixed: 'right',
          render: (h, {row}) => {
            const node = [
              <a on-click={()=>this.view(row)}>查看</a>,
            ]

            return this.$utils.link(node,<Divider type="vertical" />)
          }
        }
      ]
    }
  },
  computed: {
     searchBoxOptions(){
      const carCatRequest = () => {
        return this.$request.carCates({ pageSize: 99999, search: {} }).then(resp => {
          Promise.resolve((resp.data.list || []).map(i => ({
            value: i.id,
            label: i.name,
          })))
        })
      }
      return {
        quick:{
          default: 'carNo',
          options: [
            { value: 'carNo', label: '车辆编号' },
            { value: 'licenseNo', label: '车牌号' },
            { value: 'companyName', label: '企业名称' },
            { value: 'insuranceNo', label: '保单号' },
          ]
        },
        // more:[]
        /*,
        more:[
          this.isAS ? { label: '地区', type: 'district', key: 'districtCode' } : null,
          { label: '车辆状态', type: 'radio', key: 'multipleState', values: createDict('carMultipleState') },
          { label: '购车方案', type: 'radio', key: 'buyOptions', values: createDict('buyOptions') },
          { label: '计费状态', type: 'radio', key: 'billingState', values: createDict('billingState') },
          { label: '设备状态', type: 'radio', key: 'deviceState', values: createDict('carOnlineState') },
          { label: '绑定状态', type: 'radio', key: 'bindState', values: createDict('carBindState') },
          { label: '车辆余额', type: 'range', key: 'balance' },
          { label: '设备型号', type: 'radio', key: 'spec', values: createDict('$$device_spec','string') },
          { label: '车辆类型', type: 'select', key: 'categoryId', values: carCatRequest },
          { label: '欠费锁定', type: 'radio', key: 'effectState', values: createDict('carOOCLockType') }
        ]*/
      }
    },
  },
  created() {
    this.def = { ...this.params }
    this.search()
  },
  methods: {
    search() {
      let params = { 
        search: {
          ...this.params
        }, 
        pageSize: this.page.pageSize, 
        pageNum: this.page.pageNum
      }

      this.loading = true
      this.$request.partnerCars(params).then(resp => {
        this.loading = false
        if (!resp.code) {
          this.data = this.$utils.conv(this.$utils.flat(resp.data.list || []), {  'buyOptions': 'buyOptions', enrollDatetime:'datetime' })
          this.page.total = resp.data.total || 0
        }
      })
    },

    view(row) {
      this.$refs['view'].init(row.carNo)
    },

    reset() {
      this.params = {}
      this.search()
    },

    handleUpdate() {
      this.search()
    },

    handleSearchChange(v) {
      let params = {...v}
      if (params.balance) {
        params.leastBalanceLimit = params.balance[0]
        params.mostBalanceLimit = params.balance[1]
        delete params.balance
      }
      this.$utils.areaSet(params)
      this.params = params
      this.search()
    },
    mapview(){

    }
  },
  render(){
    const { searchBoxOptions , reset , handleSearchChange , mapview , create , columns , loading , page , data , handleUpdate} = this

    return (
      <sl-page>
        <div class='page-filter border-bottom'>
          <sl-search-combo option={searchBoxOptions} on-reset={reset} on-search={handleSearchChange}>
            {/*<Button type="primary" icon="md-map" on-click={mapview}>地图模式</Button>*/}
          </sl-search-combo>
        </div>
        <div class="pg-bd">
          <sl-table show-header={true} loading={loading} selectionKey={false} page={page} columns={columns} data={data} on-change={this.$tableChange}></sl-table>
        </div>
        <View ref="view" />
      </sl-page>
    )
  }
}